var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.0625,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#24A95D",
    stroke: "#24A95D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.751 16.6687L10.7333 16.6855L10.751 16.6687L7.32995 13.0576C7.13334 12.85 7.13334 12.513 7.32995 12.3055L8.07426 11.5198L8.05653 11.503L8.07426 11.5198C8.27016 11.313 8.58723 11.313 8.78314 11.5198L8.80086 11.503L8.78314 11.5198L11.0877 13.9524L11.1054 13.9711L11.1232 13.9524L16.0593 8.742C16.2552 8.53522 16.5723 8.53522 16.7682 8.742L17.5125 9.52768C17.7091 9.73521 17.7091 10.0722 17.5125 10.2798L11.4599 16.6687C11.264 16.8755 10.9469 16.8755 10.751 16.6687Z",
    fill: "white",
    stroke: "#24A95D",
    strokeWidth: 0.0488281
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenChecked);
export default __webpack_public_path__ + "static/media/checkGreenChecked.e23b2b52657b9a88f33b2b287c7a5488.svg";
export { ForwardRef as ReactComponent };